import { CommonData } from "../../datastructures/gamestate/gameData";

//Labeling PIXI.Text for Bars
export class lableOutputUI {
  private value: string;
  private smallFontStyle: PIXI.TextStyle;
  private bigFontStyle: PIXI.TextStyle;
  private frameLabel: string;
  private activeGameData: CommonData;

  private currency: PIXI.Text;
  private label: PIXI.Text;
  private outPut: PIXI.Text;
  private parent: PIXI.Container;

  constructor(
    parent: PIXI.Sprite,
    getLabel: string,
    activeGameData: CommonData
  ) {
    this.activeGameData = activeGameData;
    this.currency;
    this.label;
    this.outPut; //text on screen
    this.value;
    // this.parent=new PIXI.Container();
    // parent.addChild(this.parent)
    this.parent = parent;

    this.smallFontStyle;
    this.bigFontStyle;
    this.frameLabel = getLabel;
    this.setFontsStyle();
    this.createUIBox();
  }

  private createUIBox() {
    this.currency = new PIXI.Text(
      this.activeGameData.currency,
      this.smallFontStyle
    );
    this.currency.x = -this.parent.width / 2 + 20; // fix the parent with  centered anchor
    this.currency.y = -this.parent.height / 2 + 3;

    this.label = new PIXI.Text(this.frameLabel, this.smallFontStyle);
    this.label.x = -this.parent.width / 2 + 20; // fix the parent with  centered anchor
    this.label.y = this.parent.height / 2 - this.label.height - 17;

    // console.log(this.label.width)

    if (this.label.width > 120) {
      this.label.width = 120;
    }
    if (this.activeGameData.isMobile) {
      this.label.y = this.parent.height / 2 - this.label.height - 17;
    }

    this.outPut = new PIXI.Text(
      this.activeGameData.balance.getDisplayValue(),
      this.bigFontStyle
    );
    this.outPut.x = this.parent.width / 2 - this.outPut.width - 20; // fix the parent with  centered anchor
    this.outPut.y = this.parent.height / 2 - this.outPut.height - 15;
    //do not add currency on mobile or in tournament

    // if (this.activeGameData.isMobile == false) {
    if (this.activeGameData.isTournament == false) {
      // console.log(this.activeGameData.isTournament);
      this.parent.addChild(this.currency);
    }
    // }

    this.parent.addChild(this.label);
    this.parent.addChild(this.outPut);
  }

  private setFontsStyle() {
    if (this.activeGameData.isMobile) {
      //mobile
      let fontSizeA = 30;
      let fontSizeB = 40;
      this.smallFontStyle = new PIXI.TextStyle({
        fontFamily: this.activeGameData.gameTextStyle.gameFont,
        fontSize: fontSizeA,
        // fontWeight: "bold",
        fill: ["#ffffff"],
      });
      this.bigFontStyle = new PIXI.TextStyle({
        fontFamily: this.activeGameData.gameTextStyle.gameFont,
        // fontWeight: "bold",
        fontSize: fontSizeB,
        fill: "white",
        align: "right",
      });
    } else {
      //desktop
      let fontSizeA = 30;
      let fontSizeB = 45;
      this.smallFontStyle = new PIXI.TextStyle({
        fontFamily: this.activeGameData.gameTextStyle.gameFont,
        fontSize: fontSizeA,
        // fontWeight: "bold",
        fill: ["#ffffff"],
      });
      this.bigFontStyle = new PIXI.TextStyle({
        fontFamily: this.activeGameData.gameTextStyle.gameFont,
        // fontWeight: "bold",
        fontSize: fontSizeB,
        fill: "white",
        align: "right",
      });
    }
  }

  public setValue(newValueText: string) {
    // change and reposition outdisplay
    this.value = newValueText;
    this.outPut.text = this.value + "";
    this.outPut.x = this.parent.width / 2 - this.outPut.width - 20;
  }

  // changelabel(newLabel: string) {
  //     this.label.text = newLabel;
  // }
  public getValue() {
    return this.value;
  }

  public setPositionOffset(moveRight: boolean) {
    if (moveRight) {
      this.label.x = -this.parent.width / 2 + 100;
      this.currency.x = -this.parent.width / 2 + 100;
    } else {
      this.label.x = -this.parent.width / 2 + 50;
      this.currency.x = -this.parent.width / 2 + 50;
    }
  }

  public setFontSize(fontsize: number) {
    this.label.style.fontSize = fontsize;
    this.currency.style.fontSize = fontsize;
    this.outPut.style.fontSize = fontsize;
    this.label.position.set(0);
    this.currency.position.set(0);

    this.currency.x = -this.parent.width / 2 + 20; // fix the parent with  centered anchor
    this.currency.y = -this.parent.height / 2 + 3;
    this.outPut.position.set(0);

    this.label.x = -this.parent.width / 2 + 20; // fix the parent with  centered anchor
    this.label.y = this.parent.height / 2 - this.label.height;

    this.outPut.x = this.parent.width / 2 - this.outPut.width - 20; // fix the parent with  centered anchor
    this.outPut.y = this.parent.height / 2 - this.outPut.height;
    this.parent.addChild(this.currency);
  }

  public setCurrencyText = (newCurrency: string): void => {
    this.currency.text = newCurrency;
  };

  public setlabelText = (newLabel: string): void => {
    this.label.text = newLabel;
  };

  public setCurrencyPosX = (posX: number): void => {
    this.currency.x = posX;
  };
  public setOutputAlpha(alphaValue: number) {
    this.outPut.alpha = alphaValue;
  }
  public getLabel = (): PIXI.Text => {
    return this.label;
  };
}
